/**
 * Created by sagardesai on 10/07/18.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';
import * as _ from 'lodash'
import ContentLoader from "react-content-loader"

import {getData, LOGIN} from "../../util/storage";
import {getSearchQuery, isEmpty} from "../../util/utility";
import MessageUser from "../../components/MessageUser"
import ReactPaginate from 'react-paginate';
//image
import icon_favourite_active from "../../assets/images/icon-heart-active@2x.png"
import icon_favourite_inactive from "../../assets/images/icon-heart-inactive@2x.png"
import onlineCircle from '../../assets/images/icon-circle-blue@2x.png';
import {getUserProfile} from "../../util/business_logic";

class Followers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            followersList: [],
            userDataForMessage: null,
            isVisible: false,
            messageAllData: "followers",
            pageCount: 1,
            currentPage: 1,
        }
    }

    componentDidMount() {
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getFollowersList(data.token, data.api_token, getSearchQuery(), "")
                }
            })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //check if we have user information
        //check if we have user information
        // if (nextProps.broadcaster_get_my_earnings !== null &&
        //     nextProps.broadcaster_get_my_earnings.hasOwnProperty("payload") &&
        //     nextProps.broadcaster_get_my_earnings.payload !== null
        // ) {
        //     const payload = nextProps.broadcaster_get_my_earnings.payload;
        //     this.setState({
        //         pageCount:payload.last_page,
        //         currentPage:payload.current_page
        //     })
        // }

        if (nextProps.broadcaster_followers.hasOwnProperty("performSearch") &&
            nextProps.broadcaster_followers.performSearch) {
            //console.log(nextProps.broadcaster_followers)
            this.props.setSearchFollowersState(false)
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.getFollowersList(data.token, data.api_token, getSearchQuery(), "")
                    }
                })

        }
        if (nextProps.hasOwnProperty("broadcaster_followers") &&
            nextProps.broadcaster_followers.hasOwnProperty("followersList") &&
            nextProps.broadcaster_followers.followersList &&
            nextProps.broadcaster_followers.followersList !== null &&
            nextProps.broadcaster_followers.followersList.data.hasOwnProperty("data") &&
            nextProps.broadcaster_followers.followersList.data.data !== null) {
            this.setState({
                followersList: nextProps.broadcaster_followers.followersList.data.data
            })

        }

        if (nextProps.hasOwnProperty("broadcaster_favourites") &&
            nextProps.broadcaster_favourites.hasOwnProperty("favourite_unfavourite_data") &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data != null &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data.hasOwnProperty("success") &&
            !nextProps.broadcaster_favourites.isFetching && nextProps.broadcaster_favourites.isSuccess) {

            var x = document.getElementById("inputGroupSelectForFollowers").value;
            this.props.resetFavouritesUnFavouriteData()
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        const filter = x === "2" ? "online" : x === "3" ? "offline" : ""
                        this.props.getFollowersList(data.token, data.api_token, "", filter)
                        this.props.getFavouritesList(data.token, data.api_token, "", "")
                    }
                })
        }

        if (nextProps.hasOwnProperty("broadcaster_send_message") &&
            nextProps.broadcaster_send_message.hasOwnProperty("messageModal") &&
            nextProps.broadcaster_send_message.messageModal !== null &&
            nextProps.broadcaster_send_message.messageModal !== undefined) {
            // this.setState({data});
            this.setState({
                isVisible: true,
                userDataForMessage: nextProps.broadcaster_send_message.messageModal.userData,
                messageAllData: nextProps.broadcaster_send_message.messageModal.messageAllData
            })
            this.props.hideMessageModal()
        }

    }

    sortByOptionSelected = () => {
        var x = document.getElementById("inputGroupSelectForFollowers").value;
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    const filter = x === "2" ? "online" : x === "3" ? "offline" : ""
                    this.props.getFollowersList(data.token, data.api_token, "", filter)
                }
            })
    }

    handlePageClick = (selecteddata) => {
        let selected = selecteddata.selected;
        console.log(selected);
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getFollowersList(data.token, data.api_token, "", "", selected + 1)
                }
            })
    }

    clickedOnFavouriteUnFavourite = (user) => () => {
        //console.log(user)
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    if (user.is_favourite) {
                        this.props.unFavouriteViewer(data.token, data.api_token, user.user_id)
                    } else {
                        this.props.favouriteViewer(data.token, data.api_token, user.user_id)
                    }
                }
            })

    }


    clickedOnIndividualMessage = (userData) => {
        //console.log(userData)
        this.setState({
            isVisible: true,
            userDataForMessage: userData
        })
    }

    clickedOnMessageAll = () => {
        this.setState({
            isVisible: true,
            userDataForMessage: null,
            messageAllData: "followers"
        })
    }

    toggleVisibilityOfMessage = () => {
        this.setState({isVisible: !this.state.isVisible})
    }

    render() {

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container other-middle-container">
                            <div className="title-container">

                                <div>
                                    <h4>Followers
                                        {this.props.broadcaster_followers && this.props.broadcaster_followers.followersList &&
                                        <span> ({this.props.broadcaster_followers.followersList.data.total})</span>}
                                    </h4>
                                </div>

                                {this.state.followersList && this.state.followersList.length > 0 && <div>
                                    <span>Sort by</span>
                                    <select className="custom-select" id="inputGroupSelectForFollowers"
                                            onChange={this.sortByOptionSelected}>
                                        <option defaultValue="1">All</option>
                                        <option value="2">Online</option>
                                        <option value="3">Offline</option>
                                    </select>
                                    <button className="btn btn-outline-primary" id="showMessageAll"
                                            onClick={this.clickedOnMessageAll}>Announcement
                                    </button>
                                </div>}
                            </div>
                            {this.props.broadcaster_followers.isFetching && this.state.followersList && this.state.followersList.length === 0 &&
                            <ContentLoader
                                height={240}
                                speed={1}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb">

                                <rect x="10" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="10" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="10" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="90" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="90" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="90" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="170" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="170" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="170" y="75" rx="4" ry="4" width="70" height="5"/>

                            </ContentLoader>
                            }
                            <div className="row">

                                {
                                    this.state.followersList && this.state.followersList.length > 0 && _.map(this.state.followersList, (data) => {

                                        return <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4" key={data.user_id}>

                                            <div className="broadcast-wrapper followers-wrapper">
                                                <div className="followers-img">
                                                    <img src={getUserProfile(data.profile_pic)} alt="followers"/>
                                                </div>
                                                <div style={{cursor: 'pointer'}}
                                                     onClick={this.clickedOnFavouriteUnFavourite(data)}
                                                     className="followers-icon">
                                                    {data.is_favourite ?
                                                        <img src={icon_favourite_active} alt="Followers"/> :
                                                        <img src={icon_favourite_inactive} alt="Followers"/>}
                                                </div>
                                                <div className="broadcast-content">
                                                    <p className="font-weight-bold">{data.username}
                                                        {
                                                            data.status === "online" &&
                                                            <span className="online"><img src={onlineCircle}
                                                                                          alt="Online"/></span>

                                                        }
                                                    </p>
                                                    <p className="small messages">
                                                        <a href="#"
                                                           onClick={ev => {
                                                               ev.preventDefault();
                                                               this.clickedOnIndividualMessage(data)
                                                           }}
                                                           title="Message"
                                                           id="showMessage">Message</a>
                                                    </p>


                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            {
                                this.props.broadcaster_followers.followersList.data.last_page > 0 && this.props.broadcaster_followers.followersList.data.total > parseInt(this.props.broadcaster_followers.followersList.data.per_page) &&
                                <div className="row">
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"/>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"/>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"/>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4">
                                        <ReactPaginate previousLabel={"Previous"}
                                                       previousClassName={"page-item prev"}
                                                       previousLinkClassName={"page-link"}
                                                       nextLinkClassName={"page-link"}
                                                       nextLabel={"Next"}
                                                       nextClassName={"page-item next"}
                                                       breakLabel={<a href="">...</a>}
                                                       breakClassName={"break-me page-link"}
                                                       pageCount={this.props.broadcaster_followers.followersList.data.last_page}
                                                       marginPagesDisplayed={this.state.pageCount}
                                                       pageRangeDisplayed={this.state.pageCount}
                                                       pageClassName={"page-item"}
                                                       pageLinkClassName={"page-link"}
                                                       onPageChange={this.handlePageClick}
                                                       containerClassName={"pagination justify-content-end"}
                                                       forcePage={this.state.currentPage - 1}
                                                       activeClassName={"active"}
                                        />
                                    </div>
                                </div>
                            }
                            {
                                this.state.followersList && this.state.followersList.length === 0 &&
                                <div style={{textAlign: 'center', marginTop: '100px'}}>
                                    <p>Sorry, no followers at the moment. Maybe go live?</p>
                                </div>
                            }
                        </div>
                    </div>
                    <MessageUser isVisible={this.state.isVisible} userData={this.state.userDataForMessage}
                                 messageAllData={this.state.messageAllData}
                                 closeMessage={this.toggleVisibilityOfMessage}/>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        broadcaster_followers: state.broadcaster_followers,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_send_message: state.broadcaster_send_message,

    };
}

export default connect(mapStateToProps, actions)(Followers);
